import { useState } from "react";

export default function useTable ({table_headers}) {
    const [headers, setHeaders] = useState(table_headers ?? [])
    const [data, setData] = useState([]);
    const [sort, setSort] = useState({ column: null, direction: null });

     /**
   * handle sort and sort function
   * 
   * @param {string} columnName - column name in data
   */
  function handleSortByColumn(columnName) {
    if (sort.column === columnName) {
      setSort(prevSort => ({
        column: columnName,
        direction: prevSort.direction === "asc" ? "desc" : "asc",
      }));
    } else {
      setSort({
        column: columnName,
        direction: "asc",
      });
    }
    const sorted = [...data].sort((a, b) => {
      // two adjacent columns
      const columnA = a[columnName] ?? "";
      const columnB = b[columnName] ?? "";

      // comparing function between different types of datas
      if (typeof columnA === "number" && typeof columnB === "number") {
        return sort.direction === "asc" ? columnA - columnB : columnB - columnA;
      } else if (typeof columnA === "boolean" && typeof columnB === "boolean") {
        if (columnA && !columnB) {
          return sort.direction === "asc" ? -1 : 1;
        } else if (!columnA && columnB) {
          return sort.direction === "asc" ? 1 : -1;
        } else {
          return 0;
        }
      } else {
        const columnALower = columnA.toString().toLowerCase();
        const columnBLower = columnB.toString().toLowerCase();
        if (columnALower < columnBLower) {
          return sort.direction === "asc" ? -1 : 1;
        } else if (columnALower > columnBLower) {
          return sort.direction === "asc" ? 1 : -1;
        } else {
          return 0;
        }
      }
    });

    setData(sorted);
  }
      
    return {
        headers,
        data,
        sort,
        setHeaders,
        setData,
        setSort,
        handleSortByColumn
    }
}